import { collection, doc } from 'firebase/firestore';
import { db } from './config';

/* eslint-disable no-undef */

/**
 * Tek Firestore veri kökü — Firebase Console'daki gerçek yol: artifacts/finly-app/public/data
 */
export const DEFAULT_FIRESTORE_APP_ID = 'finly-app';

export const CANONICAL_APP_ID =
  process.env.REACT_APP_FIRESTORE_APP_ID || DEFAULT_FIRESTORE_APP_ID;

/** Girişte profil araması — yalnızca kimlik doğrulama; oturum hep CANONICAL kullanır */
export const LOGIN_LOOKUP_APP_IDS = [
  CANONICAL_APP_ID,
  typeof __app_id !== 'undefined' ? String(__app_id) : null,
  'finly-6326',
  process.env.REACT_APP_FIREBASE_PROJECT_ID,
  'atletik-yuzme-app',
]
  .filter(Boolean)
  .map((id) => String(id).replace(/\//g, '-'))
  .filter((id, index, list) => list.indexOf(id) === index);

/** @deprecated LOGIN_LOOKUP_APP_IDS kullanın */
export const FIRESTORE_APP_ID_CANDIDATES = LOGIN_LOOKUP_APP_IDS;

export const dataRootSegments = (appId) => ['artifacts', appId, 'public', 'data'];

export const collectionRefForApp = (appId, name) =>
  collection(db, ...dataRootSegments(appId), name);

export const docRefForApp = (appId, collectionName, docId) =>
  doc(db, ...dataRootSegments(appId), collectionName, docId);

export const studentSubColForApp = (appId, studentId, subName) =>
  collection(db, ...dataRootSegments(appId), 'students', studentId, subName);

export const isCanonicalAppId = (appId) => appId === CANONICAL_APP_ID;

/** İnsan okunur tam veri kökü — dokümantasyon ve doğrulama için */
export const CANONICAL_DATA_ROOT_PATH = `artifacts/${CANONICAL_APP_ID}/public/data`;
